export const LeverageType = {
  AMPLIFY: 0,
  MARGIN_TRADE: 1,
};
